import React from "react";
import { s } from "../styles";

export default function Page2() {
  return (
    <div className="t4-page">
      <div style={s.p2}>
        <div style={s.c2}>
          <div style={{ fontWeight: "bold" }}>
            If you file your T4 information return electronically, do not fill out this T4 Summary.
          </div>
          <h3 style={{ fontSize: 13, margin: "16px 0 6px" }}>Mandatory electronic filing</h3>
          <div>
            You must file electronically if you have more than 5 information returns of the same type.
          </div>
          <div style={{ marginTop: 6 }}>
            You may choose one of the following electronic filing formats:
          </div>
          <ul>
            <li>Internet file transfer (XML)</li>
            <li>Web Forms</li>
          </ul>
          <div>
            For more information about filing electronically, go to <b>canada.ca/filing-info-returns</b>.
          </div>
          <div style={{ marginTop: 6 }}>
            You can also file your information returns online using the "File a return" service. Go to:
          </div>
          <ul>
            <li>
              My Business Account at <b>canada.ca/cra-sign-in-services</b>, if you are the business owner
            </li>
            <li>
              Represent a Client at <b>canada.ca/cra-sign-in-services</b>, if you are an authorized representative or employee
            </li>
          </ul>
          <h3 style={{ fontSize: 13, margin: "16px 0 6px" }}>Filing on paper</h3>
          <div>
            Fill out this form using the instructions at <b>canada.ca/taxes-slips</b>.
          </div>
          <div style={{ marginTop: 6 }}>
            The employer's name and payroll program account number have to be the same as shown on your statement of account.
          </div>
          <div style={{ marginTop: 6 }}>
            To get our forms and publications, go to <b>canada.ca/cra-forms</b> or call <b>1-800-959-5525</b>.
          </div>
          <div style={{ marginTop: 6 }}>
            Send this T4 Summary and the related T4 slips to:
          </div>
          <div style={{ margin: "6px 0 6px 20px", lineHeight: 1.4 }}>
            Jonquière TC
            <br />
            T4 Program
            <br />
            Post Office Box 1300 LCD Jonquière
            <br />
            Jonquière QC&nbsp;&nbsp;G7S 0L5
          </div>
          <h3 style={{ fontSize: 13, margin: "16px 0 6px" }}>Make a payment</h3>
          <div>Make your payment using:</div>
          <ul>
            <li>
              your Canadian bank or credit union's online banking, mobile app, or telephone service
            </li>
            <li>
              the CRA's My Payment service at <b>canada.ca/cra-my-payment</b> with your activated debit card from a participating Canadian bank or credit union with a Visa Debit or Debit Mastercard logo (does not include credit cards)
            </li>
            <li>
              pre-authorized debit (PAD) at <b>canada.ca/cra-sign-in-services</b> which lets you set up payments, pay an amount due, and view or modify your account history
            </li>
            <li>
              the "Proceed to pay" button on the "View and pay account balance" page within My Business Account
            </li>
            <li>
              your credit card, Interac e-Transfer, or PayPal through one of the third-party service providers for a fee
            </li>
          </ul>
          <div>
            For more information, go to <b>canada.ca/payments</b>.
          </div>
          <div style={{ fontSize: 9, lineHeight: 1.35, marginTop: 12 }}>
            Personal information (including the SIN) is collected and used to administer or enforce the Income Tax Act and related programs and activities. The information collected may be disclosed to other federal, provincial, territorial, aboriginal, or foreign government institutions to the extent authorized by law. Under the Privacy Act, individuals have a right of protection, access to and correction of their personal information, and to file a complaint with the Privacy Commissioner of Canada. Refer to Personal Information Bank CRA PPU 047 on Info Source at <b>canada.ca/cra-info-source</b>.
          </div>
        </div>
        <div style={s.c2}>
          <div style={{ fontWeight: "bold" }}>
            Si vous produisez votre déclaration de renseignements T4 électroniquement, ne remplissez pas ce formulaire.
          </div>
          <h3 style={{ fontSize: 13, margin: "16px 0 6px" }}>
            Production obligatoire par voie électronique
          </h3>
          <div>
            Vous devez produire par voie électronique si vous avez plus de 5 déclarations de renseignements du même type.
          </div>
          <div style={{ marginTop: 6 }}>
            Vous pouvez choisir une des méthodes de production électronique suivantes :
          </div>
          <ul>
            <li>Le transfert de fichiers par Internet (XML)</li>
            <li>Les formulaires Web</li>
          </ul>
          <div>
            Pour en savoir plus sur la production par voie électronique, allez à <b>canada.ca/declarations-renseignements</b>.
          </div>
          <div style={{ marginTop: 6 }}>
            Vous pouvez aussi produire vos déclarations de renseignements en ligne au moyen du service « Produire une déclaration » à :
          </div>
          <ul>
            <li>
              Mon dossier d'entreprise en allant à <b>canada.ca/arc-services-ouverture-session</b>, si vous êtes le propriétaire de l'entreprise;
            </li>
            <li>
              Représenter un client en allant à <b>canada.ca/arc-services-ouverture-session</b>, si vous êtes un représentant ou un employé autorisé.
            </li>
          </ul>
          <h3 style={{ fontSize: 13, margin: "16px 0 6px" }}>Production sur papier</h3>
          <div>
            Remplissez ce formulaire selon les directives indiquées à <b>canada.ca/impots-feuillets</b>.
          </div>
          <div style={{ marginTop: 6 }}>
            Le nom et le numéro de compte de programme de retenues sur la paie doivent être les mêmes que ceux qui figurent sur votre relevé de compte.
          </div>
          <div style={{ marginTop: 6 }}>
            Pour obtenir nos formulaires et publications, allez à <b>canada.ca/arc-formulaires</b> ou composez le <b>1-800-959-7775</b>.
          </div>
          <div style={{ marginTop: 6 }}>
            Envoyez ce sommaire et les feuillets T4 connexes au :
          </div>
          <div style={{ margin: "6px 0 6px 20px", lineHeight: 1.4 }}>
            CF de Jonquière
            <br />
            Programme T4
            <br />
            Case postale 1300, PDF Jonquière
            <br />
            Jonquière QC&nbsp;&nbsp;G7S 0L5
          </div>
          <h3 style={{ fontSize: 13, margin: "16px 0 6px" }}>Faire un paiement</h3>
          <div>Effectuez votre paiement en utilisant :</div>
          <ul>
            <li>
              les services bancaires en ligne, l'application mobile ou les services téléphoniques de votre banque canadienne ou de votre caisse de crédit canadienne;
            </li>
            <li>
              le service Mon paiement de l'ARC à <b>canada.ca/mon-paiement-arc</b> avec votre carte de débit activée portant un logo Visa Débit ou Mastercard Débit;
            </li>
            <li>
              le débit préautorisé (DPA) à <b>canada.ca/arc-services-ouverture-session</b> qui vous permet d'établir des paiements, de payer un montant dû et de consulter ou modifier votre compte;
            </li>
            <li>
              le bouton « Procéder à un paiement » dans la page « Voir et payer le solde du compte » de Mon dossier d'entreprise;
            </li>
            <li>
              votre carte de crédit, Virement Interac ou PayPal auprès de l'un des tiers fournisseurs de services, moyennant des frais.
            </li>
          </ul>
          <div>
            Pour en savoir plus, allez à <b>canada.ca/paiements</b>.
          </div>
          <div style={{ fontSize: 9, lineHeight: 1.35, marginTop: 12 }}>
            Les renseignements personnels (y compris le NAS) sont recueillis et utilisés aux fins d'appliquer ou d'exécuter la Loi de l'impôt sur le revenu et des programmes et activités connexes. Les renseignements recueillis peuvent être communiqués à une autre institution gouvernementale dans la mesure où le droit l'autorise. Selon la Loi sur la protection des renseignements personnels, les particuliers ont le droit à la protection, à l'accès et à la correction de leurs renseignements personnels, et de déposer une plainte auprès du Commissaire à la protection de la vie privée du Canada. Consultez le fichier ARC PPU 047 sur Info Source à <b>canada.ca/arc-info-source</b>.
          </div>
        </div>
      </div>
    </div>
  );
}